import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Wrapper = styled('div')<{ theme?: TTheme }>`
    width: 100%;
    height: inherit;
    overflow-y: auto;
    padding-right: 10px;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.colors.greys[200]};
        border-radius: 3px;
    }
`
